/**
 * @generated SignedSource<<fdcb588ca2ae9a77ce0c27ddd45625e3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HotelEditMainGeneral_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CitySelect_data">;
  readonly " $fragmentType": "HotelEditMainGeneral_data";
};
export type HotelEditMainGeneral_data$key = {
  readonly " $data"?: HotelEditMainGeneral_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"HotelEditMainGeneral_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HotelEditMainGeneral_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CitySelect_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "4f11d147aaa1d6771712f1600ede7075";

export default node;
